module.exports = __webpack_public_path__ + "img/infografia.ffe78ae6.svg";